// extracted by mini-css-extract-plugin
export default {"subtext":"z-input-subtext_subtext__7h0As"};